// extracted by mini-css-extract-plugin
export var addWidgetButton = "_q-6";
export var backButton = "_q-1";
export var legacyWidgetContainer = "_q-5";
export var pageContainer = "_q-2";
export var settingsContent = "_q-0";
export var widgetSubsectionItem = "_q-3";
export var widgetSubsectionItemContent = "_q-4";